const windowHasLoaded = (async () => {
  if (typeof window === 'undefined') {
    return true;
  }
  const isLoaded = await (() => {
    const eventProm = new Promise<boolean>((resolve) => {
      window.addEventListener('load', () => {
        resolve(true);
      });
    });
    const timeOutProm = new Promise<boolean>((resolve) => {
      // Cases where window is loaded BEFORE react is hydrated can happen, this is a fallback case
      setTimeout(() => {
        resolve(true);
      }, 3000);
    });
    return Promise.any([eventProm, timeOutProm]).then((d) => d);
  })();
  return isLoaded;
})();

export const windowIsLoaded = async (): Promise<boolean> => {
  return windowHasLoaded;
};
